export default __webpack_public_path__ + "static/media/login-image.26cf6780.jpg";